import { HttpMethods } from "@kvix/shared";

export const getLocation = async (): Promise<string> => {
  const response = await fetch(`/api/country`, {
    method: HttpMethods.GET,
  });
  const json = await response.json();
  return json.country;
};
